import requestAction from '../utils/requestAction'

export const fetchGeneralDesc = ( params: string = '', handleResponse?: (response: any) => void ) =>
  requestAction('GENERAL_DESC_LIST', params)('generalDesc', 'GET',
undefined,
undefined,
undefined,
(_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })

